import { __ } from '@wordpress/i18n';
import type { HslaColor } from 'react-colorful';
import { InputWithSlider } from './input-with-slider';
import type { HslInputProps } from './types';

export const HslInput = ( { hsla, onChange, enableAlpha }: HslInputProps ) => {
	const updateHSLAValue = ( partialNewValue: Partial< HslaColor > ) => {
		onChange( {
			...hsla,
			...partialNewValue,
		} );
	};

	return (
		<>
			<InputWithSlider
				min={ 0 }
				max={ 359 }
				label={ __( 'Hue (HSL H value)' ) }
				abbreviation="H"
				value={ hsla.h }
				onChange={ ( nextH: number ) => {
					updateHSLAValue( { h: nextH } );
				} }
			/>
			<InputWithSlider
				min={ 0 }
				max={ 100 }
				label={ __( 'Saturation' ) }
				abbreviation="S"
				value={ hsla.s }
				onChange={ ( nextS: number ) => {
					updateHSLAValue( { s: nextS } );
				} }
			/>
			<InputWithSlider
				min={ 0 }
				max={ 100 }
				label={ __( 'Lightness' ) }
				abbreviation="L"
				value={ hsla.l }
				onChange={ ( nextL: number ) => {
					updateHSLAValue( { l: nextL } );
				} }
			/>
			{ enableAlpha && (
				<InputWithSlider
					min={ 0 }
					max={ 100 }
					label={ __( 'Alpha (HSL A value)' ) }
					abbreviation="A"
					value={ Math.trunc( 100 * hsla.a ) }
					onChange={ ( nextA: number ) => {
						updateHSLAValue( { a: nextA / 100 } );
					} }
				/>
			) }
		</>
	);
};
